import type { StoreActionApi } from 'react-sweet-state';
import { createStore, createHook } from 'react-sweet-state';

interface EditorAnnotationsState {
	annotations: string[];
}
const initialState: EditorAnnotationsState = { annotations: [] };

const actions = {
	setEditorAnnotations:
		(newAnnotations: string[]) =>
		({ setState }: StoreActionApi<EditorAnnotationsState>) => {
			setState({ annotations: newAnnotations });
		},
};

const EditorAnnotationsStore = createStore({
	initialState,
	actions,
	name: 'EditorAnnotationsStore',
});

export const useEditorAnnotations = createHook(EditorAnnotationsStore);
